/* Section — Phase B1 layout primitive.
 *
 * Semantic block within a Page. Replaces the ad-hoc
 * `<div style={{ marginBottom: var(--space-6) }}><h2 ...>...</h2>...</div>`
 * pattern that's scattered through every view.
 *
 * The optional `title` slot accepts a string or a ReactNode (so callers
 * can compose a heading with a badge / count / right-aligned controls).
 * When `title` is omitted, the section renders body content with the
 * standard spacing — useful for grouping ungrouped content blocks.
 *
 * Spacing: each Section reserves `var(--space-6)` below itself; the
 * last-child override keeps the page from gaining a phantom gutter at
 * the bottom.
 */
import React from "react";

interface SectionProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  /** Optional id — useful when sections become deep-linkable. */
  id?: string;
}

export default function Section({ title, children, className = "", id }: SectionProps) {
  return (
    <section id={id} className={`v2-section ${className}`.trim()}>
      {title ? <h2 className="v2-section__title">{title}</h2> : null}
      {children}
    </section>
  );
}
